import React, {useCallback} from 'react';
import {GatewayGetSchema} from '../../../../api/DBSchema/Gateway';
import LockToPlanContainer from '../../../../components/Editor/LockToPlanContainer';
import {useTranslation} from "react-i18next";
import BaseVpnCommunity from '../../AbstractObjects/GatewayPlan/InnerPages/BaseVpnCommunity';
import {communityIcon} from "../../../../assets/images/headerIcons";

const pageSchema = GatewayGetSchema.pages.vpnCommunity;
const pageId = pageSchema.pageId;

function GatewayVpnCommunity({
    gatewayObject,
    planObject,
    setGatewayData,
    isExternal
}) {
    const gatewayPage = gatewayObject[pageId];
    const planPage = planObject[pageId];
    const lockedToPlan = gatewayPage[pageSchema.lockedToPlan];
    const { t } = useTranslation();

    let currentPageData;
    if (lockedToPlan) {
        currentPageData = planPage;
    } else {
        currentPageData = gatewayPage;
    }

    const onToggleLockedToPlan = useCallback(locked => {
        // If unlocked page from plan, set gateway fields to plan's fields
        if (!locked) {
            setGatewayData([pageId, pageSchema.communityDataList], planPage[pageSchema.communityDataList]);
            setGatewayData([pageId, pageSchema.useDnsName], planPage[pageSchema.useDnsName]);
            setGatewayData([pageId, pageSchema.noLocalConnsEncrypt], planPage[pageSchema.noLocalConnsEncrypt]);
        }
        setGatewayData([pageId, pageSchema.lockedToPlan], locked);

    }, [setGatewayData, planPage]);

    const baseVpnCommunity = (
        <BaseVpnCommunity
            pageData={currentPageData}
            setObjectData={setGatewayData}
            pageDisabled={lockedToPlan}
            isGateway={true}
            isGatewayExternal={isExternal}
        />
    );

    return (
        isExternal ? (
            baseVpnCommunity
        ) : (
            <LockToPlanContainer
                locked={lockedToPlan}
                onToggleLocked={onToggleLockedToPlan}
                labelText={t('SMC_GATEWAY_COMMUNITY')}
                icon={communityIcon}
            >
                { baseVpnCommunity }
            </LockToPlanContainer>
        )
    );
}

export default GatewayVpnCommunity;